import { css } from '@emotion/core';

export default {
  photoSlide: css({
    margin: 'auto',
    maxWidth: '960px',
  }),
};
